import React, {FC} from 'react'

import cn from 'classnames/bind'

import IconThemeBlue1 from 'assets/themes/blue-1.svg'
import IconThemeBlue2 from 'assets/themes/blue-2.svg'
import IconThemeGray1 from 'assets/themes/gray-1.svg'
import IconThemeGray2 from 'assets/themes/gray-2.svg'
import IconThemeGreen1 from 'assets/themes/green-1.svg'
import IconThemeGreen2 from 'assets/themes/green-2.svg'

import s from './PayStubChooseTemplateNew.module.scss'

const cx = cn.bind(s)

type TTemplateThemes = {
	className?: string
	activeTemplate: IPayStubTemplates
	handleTemplateTheme: (id: number, theme: IPayStubTemplates['theme']) => void
}

export const TemplateThemesNew: FC<TTemplateThemes> = ({activeTemplate, handleTemplateTheme}) => {
	return (
		<ul className={cx('themes')}>
			<li
				className={cx('themes__item', activeTemplate.theme === 'gray' ? 'active' : '')}
				onClick={() => handleTemplateTheme(activeTemplate.id, 'gray')}
				aria-hidden="true">
				<div className={cx('themes__icon')}>
					{activeTemplate.id === 4 ? <IconThemeGray1 /> : <IconThemeGray2 />}
				</div>
				<div className={cx('themes__text')}>Gray</div>
			</li>
			<li
				className={cx('themes__item', activeTemplate.theme === 'green' ? 'active' : '')}
				onClick={() => handleTemplateTheme(activeTemplate.id, 'green')}
				aria-hidden="true">
				<div className={cx('themes__icon')}>
					{activeTemplate.id === 4 ? <IconThemeGreen1 /> : <IconThemeGreen2 />}
				</div>
				<div className={cx('themes__text')}>Green</div>
			</li>
			<li
				className={cx('themes__item', activeTemplate.theme === 'blue' ? 'active' : '')}
				onClick={() => handleTemplateTheme(activeTemplate.id, 'blue')}
				aria-hidden="true">
				<div className={cx('themes__icon')}>
					{activeTemplate.id === 4 ? <IconThemeBlue1 /> : <IconThemeBlue2 />}
				</div>
				<div className={cx('themes__text')}>Blue</div>
			</li>
		</ul>
	)
}
